import { makeAutoObservable } from "mobx";
import {
  pagingMedications,
  getMedication,
  createMedication,
  editMedication,
  deleteMedication,
  checkCode,
} from "./MedicationService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

export default class MedicationStore {
  medicationList = [];
  selectedMedication = null;
  selectedMedicationList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  keyword = "";
  loadingInitial = false;
  shouldOpenEditorDialog = false;
  shouldOpenConfirmationDialog = false;
  shouldOpenConfirmationDeleteListDialog = false;
  searchObject = {
    keyword: "",
    type: null,
    classify: null,
    stockKeepingUnit: null,
    medicationTreatmentType: null,
    dictionarySytemId: null,
    sortName: null,//sort tên
    sortCode: null,//sort mã
    sortContent: null,//hàm lượng
    sortUnit: null,//đơn vị
    sortStockKeepingUnit: null,//đóng gói
  };

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  updatePageData = (item) => {
    
    if (item != null) {
      this.page = 1;
      this.keyword = item.keyword;
      this.search();
    } else {
      this.search();
    }
  };

  search = async () => {
    this.loadingInitial = true;
    var searchObject = {
      keyword: this.keyword,
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
      type: this.searchObject.type,
      classify : this.searchObject.classify,
      stockKeepingUnitId: this.searchObject.stockKeepingUnit?.id,
      medicationTreatmentType: this.searchObject.medicationTreatmentType,
      dictionarySytemId: this.searchObject.groupMedication?.id,
      sortName: this.searchObject.sortName,//sort tên
      sortCode: this.searchObject.sortCode,//sort mã
      sortContent: this.searchObject.sortContent,//hàm lượng
      sortUnit: this.searchObject.sortUnit,//đơn vị
      sortStockKeepingUnit: this.searchObject.sortStockKeepingUnit,//đóng gói
    };
    try {
      let data = await pagingMedications(searchObject);
      this.medicationList = data.data.content;
      this.totalElements = data.data.totalElements;
      this.totalPages = data.data.totalPages;
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      toast.warning("toast.load_fail");
      this.setLoadingInitial(false);
    }
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleSetSearchObject = (item) => {
    if (item.pageIndex) {
      this.page = item.pageIndex;
    }
    this.searchObject = item;
  }

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  handleEditMedication = (id) => {
    this.getMedication(id).then(() => {
      this.shouldOpenEditorDialog = true;
    });
  };

  handleClose = () => {
    this.shouldOpenEditorDialog = false;
    this.shouldOpenConfirmationDialog = false;
    this.shouldOpenConfirmationDeleteListDialog = false;
    this.updatePageData();
  };

  handleDelete = (id) => {
    this.getMedication(id).then(() => {
      this.shouldOpenConfirmationDialog = true;
    });
  };

  handleDeleteList = () => {
    this.shouldOpenConfirmationDeleteListDialog = true;
  };

  handleConfirmDelete = () => {
    this.deleteMedication(this.selectedMedication.id);
  };

  handleConfirmDeleteList = async () => {
    let listAlert = [];
    for (var i = 0; i < this.selectedMedicationList.length; i++) {
      try {
        await deleteMedication(this.selectedMedicationList[i].id);
      } catch (error) {
        listAlert.push(this.selectedMedicationList[i].name);
        console.log(error);
        console.log(listAlert.toString());
        toast.warning("toast.delete_fail");
      }
    }
    this.handleClose();
    toast.success("Đã xóa thành công!");
  };

  handleSelectMedication = (medication) => {
    this.selectedMedication = medication;
  };

  handleSelectListMedication = (medications) => {
    this.selectedMedicationList = medications;
  };

  getMedication = async (id) => {
    // console.log(id)
    if (id != null) {
      try {
        let data = await getMedication(id);
        
        this.handleSelectMedication(data.data);
        
      } catch (error) {
        console.log(error);
        toast.warning("toast.get_fail");
      }
    } else {
      this.handleSelectMedication(null);
    }
  };

  createMedication = async (medication) => {
    try {
      let responseCheckCode = await checkCode(medication);
      if (responseCheckCode.data) {
        toast.warning("Mã đã được sử dụng!");
      } else {
        await createMedication(medication);
        toast.success("Thêm mới thành công!");
        this.handleClose();
      }
    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi thêm mới!");
    }
  };

  editMedication = async (medication) => {
    try {
      let responseCheckCode = await checkCode(medication);
      if (responseCheckCode.data) {
        toast.warning("Mã đã được sử dụng!");
      } else {
        await editMedication(medication);
        toast.success("Cập nhật thành công!");
        this.handleClose();
      }
      
    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi cập nhật!");
    }
  };

  deleteMedication = async (id) => {
    try {
      const res = await deleteMedication(id);
      if (res?.data) {
        toast.success("Đã xoá bản ghi");
      } else {
        toast.warning("Không thể xoá vì có dữ liệu ràng buộc");
      }
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.error("Có lỗi xảy ra, vui lòng thử lại sau");
    }
  };
  resetSearchObject = () => {
    this.searchObject = {
      type: null,
      classify: null,
      stockKeepingUnit: null,
      medicationTreatmentType: null,
      dictionarySytemId: null,
      sortName: null,//sort tên
      sortCode: null,//sort mã
      sortContent: null,//hàm lượng
      sortUnit: null,//đơn vị
      sortStockKeepingUnit: null,//đóng gói
    }
    this.keyword = "";
    this.page = 1;
    this.rowsPerPage = 10;
  }

  preHandleSubmitData = (values) =>{
    return {
      ...values,
      code: values?.code?.trim(),
      name: values?.name?.trim(),
      manufacturer: values?.manufacturer?.trim(),
      content: values?.content?.trim(),
      unit: values?.unit?.trim(),
      nameAbbreviation: values?.nameAbbreviation?.trim(),
      nameEnglish: values?.nameEnglish?.trim(),
      codeStandard: values?.codeStandard?.trim(),
    }
  }

  handleSetSortField = item => {
    this.page = 1;
    this.searchObject = {
      ...this.searchObject,
      //set các trường sort khác = null
      sortName: null,//sort tên
      sortCode: null,//sort mã
      sortContent: null,//hàm lượng
      sortUnit: null,//đơn vị
      sortStockKeepingUnit: null,//đóng gói
      ...item,
    };
    this.updatePageData();
  }
}
